import { BlockResult } from "./helpers/BlockResult";
// import { AverageRateOne, LoadLevelOne, PaycheckOne } from "../exports"

const BlockOne = (props) => {
  const { statDat, saveFullApartSquare, CustomBox } = props;

  return (
    <>
      <BlockResult statDat={statDat} saveFullApartSquare={saveFullApartSquare} CustomBox={CustomBox}/>
    </>
  );
};

export default BlockOne;
